import api from '@/api'
import Cookies from 'js-cookie'

export default {
  state: () => ({
    carts: [],
    fromCart: true,
    payCarts: Cookies.get('payCarts') && JSON.parse(Cookies.get('payCarts'))
  }),
  getters: {
    carts(state) {
      return state.carts
    },
    fromCarts(state) {
      return state.fromCart
    },
    payCarts(state) {
      return state.payCarts
    }
  },
  mutations: {
    setCarts(state, payload) {
      state.carts = payload
    },
    setPayCarts(state, payload) {
      Cookies.set('payCarts', payload)
      state.payCarts = payload
    },
    setFromCart(state, payload) {
      state.fromCart = payload
    },
    resetPayCart(state) {
      Cookies.remove('payCarts')
      state.payCarts = ''
    }
  },
  actions: {
    async getCarts({ commit }, params) {
      try {
        const { data, success } = await api.cart.carts(params) || {}
        if (success) {
          commit('setCarts', data)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async addCart({ commit, state }, data) {
      try {
        let hasItem = false
        let cartList = state.carts.map((item) => {
          if (item.item.id === data.item.id) {
            hasItem = true
            item.num = item.num + data.num
          }
          return item
        })

        if (!hasItem) {
          cartList = [...cartList, data]
        }
        const { success } = await api.cart.updateCart(cartList) || {}
        if (success) {
          commit('setCarts', cartList)
        }
        return success
      } catch (err) {
        console.log(err)

        return false
      }
    },
    async updateCart({ commit, state }, data) {
      try {
        const cartList = state.carts.map(item => {
          return item.item.id === data.item.id ? data : item
        })
        const { success } = await api.cart.updateCart(cartList) || {}
        if (success) {
          commit('setCarts', cartList)
        }
        return success
      } catch (err) {
        console.log(err)
        return false
      }
    },
    async deleteCart({ commit, state }, data) {
      try {
        const cartList = state.carts.filter(item => item.item.id !== data.item.id)
        const { success } = await api.cart.updateCart(cartList) || {}
        if (success) {
          commit('setCarts', cartList)
        }
        return success
      } catch (err) {
        console.log(err)
        return false
      }
    },
    resetPayCart({ commit }) {
      commit('resetPayCart')
    },
    setPayCarts({ commit }, data) {
      commit('setPayCarts', data)
    },
    setFromCart({ commit }, data) {
      commit('setFromCart', data)
    }
  }
}
